import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  deleteContract,
  deletePolicyHolderInsuree,
  fetchPolicyHolderByInsuree,
  loadingUser,
  printInsureeReport,
  fetchContracts
} from "../../action";
import "../../styles/theme.scss";
import { useTranslation } from "react-i18next";
import {
  Button,
  Grid,
  Typography,
  Paper,
  IconButton,
  Input,
} from "@mui/material";
import TableN from "../../reusableComponents/components/generics/TableN"
import { styled } from "@mui/system";
import { apiHeaders, decodeId, formatDateForFr, formatDateFromISO, getValueLabel } from "../../utils/helper";
import { useNavigate } from "react-router-dom";
import { PORTAL_CONTRACT } from "../../utils/constant";
import DeleteForeverIcon from '@mui/icons-material/DeleteForever';
import DialogBox from "../../reusableComponents/components/dialogs/DialogBox"
import SaveAltRoundedIcon from '@mui/icons-material/SaveAltRounded';

const StyledPaper = styled(Paper)(({ theme }) => ({
  ...theme.paper.paper,
}));

const StyledPaperHeader = styled(Grid)(({ theme }) => ({
  ...theme.paper.header,
  fontSize: 600,
  padding: ".8rem",
}));
function ContractDeclarationTable({ policyHolderId, filter, setInsureeData, setSnackbarMessage}) {
  const SignInSuccess = useSelector((state) => state);
  const token = localStorage.getItem("token");
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const [printData, setPrintData] = useState();
  const [policyHolderData, setPolicyHolderData] = useState();
  const [rowDataForEdit, setRowDataForEdit] = useState(null);
  const [currentUser, setCurrentUSer] = useState();
  const [showDialog, setShowDialog] = useState(false);
  const [showUpdateDialog, setShowUpdateDialog] = useState(false);
  const [deleteDialogOpen, setDeleteDialogOpen] = useState(false);
  const [insureeToDelete, setInsureeToDelete] = useState(null);
  const [page, setPage] = useState(0);
  const [pageSize, setPageSize] = useState(10);
  const [pageInfo, setPageInfo] = useState();
  const [endCursors, setEndCursors] = useState(null);
  const [startCursors, setStartCursors] = useState(null);
  const PolicyholderIdStore = localStorage.getItem("policyholderId");
  const navigate = useNavigate();
  useEffect(() => {
    dispatch(loadingUser(token));
  }, []);
  // useEffect(() => {
  //   if (!!policyHolderId?.id) {
  //     dispatch(fetchPolicyHolderByInsuree(policyHolderId?.id));
  //   }
  // }, [policyHolderId, filter]);
  useEffect(() => {
    if (SignInSuccess?.profileReducer?.contracts) {
      setPolicyHolderData(SignInSuccess?.profileReducer?.contracts);
      setPageInfo(SignInSuccess?.profileReducer?.contractsPageInfo.totalCount);
      setStartCursors(
        SignInSuccess?.profileReducer?.contractsPageInfo
          ?.endCursor
      );
      setEndCursors(
        SignInSuccess?.profileReducer?.contractsPageInfo
          ?.startCursor
      );
    }
  }, [SignInSuccess?.profileReducer?.contracts]);
  useEffect(() => {
    let params = buildQueryParams({
      filters: filter,
      pageSize,
      beforeCursor: endCursors,
      afterCursor: startCursors,
      orderBy: ["code"],
      policyHolderId: PolicyholderIdStore,
    });
    if (PolicyholderIdStore) {
      dispatch(fetchContracts(params));
    }
  }, [page, pageSize]);
  useEffect(() => {
    if (SignInSuccess?.profileReducer?.printInsuree) {
      setPrintData(SignInSuccess?.profileReducer?.printInsuree);
    }
  }, [printData, SignInSuccess]);
  useEffect(() => {
    if (printData) {
      let contentType = "pdf";
      displayPrintWindow(printData, contentType);
    }
  }, [printData]);
  // useEffect(() => {
  //   const afterCursor = pageInfo?.endCursor;
  //   const beforeCursor = pageInfo?.startCursor;

  //   dispatch(
  //     fetchPolicyHolderByInsuree(
  //       policyHolderId?.id,
  //       pageSize,
  //       afterCursor,
  //       beforeCursor
  //     )
  //   );
  // }, [page, pageSize]);

  const handleEdit = (rowData) => {
    setShowUpdateDialog(true);
    setRowDataForEdit(rowData);
  };
  const displayPrintWindow = (base64Data, contentType) => {
    const printWindow = window.open(
      "",
      "Print Window",
      "width=600, height=400"
    );
    printWindow.document.open();

    if (contentType === "pdf") {
      // printWindow.print(`<embed type="application/pdf" width="100%" height="100%" src="data:application/pdf;base64,${base64Data}" />`);
      printWindow.document.write(
        `<embed type="application/pdf" width="100%" height="100%" src="data:application/pdf;base64,${base64Data}" />`
      );
    } else {
      printWindow.document.write(
        `<img src="data:image/png;base64,${base64Data}" />`
      );
    }
    printWindow.document.close();
  };
  const printReport = async (edited) => {
    await dispatch(printInsureeReport(edited));
  };
  const handleInsureeDownload = async (contract) => {
    // let encodedCode = encodeURIComponent(policyHolderId);.
    let encodedCode = decodeId(contract.id);
    let url_import = `${process.env.REACT_APP_BACKEND_URL}/api/contract/export/${encodedCode}/contracts`;
    try {
      const response = await fetch(url_import, {
        headers: apiHeaders,
        method: "GET",
        credentials: "same-origin",
      });
      if (response.status >= 400) {

        return;
      }
      const blob = await response.blob();
      const url = window.URL.createObjectURL(blob);
      const a = document.createElement("a");
      a.href = url;
      // a.download = this.userlang === "fr" ? "liste des assurées Ouvrant droit.xlsx" : "policyholder_insurees.xlsx";
      a.download = "contract.xlsx";
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
    } catch (error) {
      alert(
        error?.message ??
          `An error occurred. Please contact your administrator. ${error?.message}`
      );
    }
  };
  const headers = () => {
    var h = [
      t("Code"),
      t("Amount"),
      t("Payemnt Due Date"),
      t("Created From"),
      t("Valid Month To"),
      t("Status"),
      t("Actions"),
    ];

    return h;
  };

  const handleDeleteClick = (rowData) => {
    setInsureeToDelete(rowData);
    setDeleteDialogOpen(true);
  };
  const handleDeleteAgree = async () => {
    dispatch(deleteContract(insureeToDelete?.id))
    setDeleteDialogOpen(false);
    setSnackbarMessage(t("Contract Deleted SucessFully"))
  };
  const itemFormatters = () => {
    const result = [
      (contract) => (!!contract.code ? contract.code : ""),
      (contract) => (!!contract.amount ? `XAF ${contract.amount}` : ""),
      (contract) =>
        !!contract.dateCreated
          ? formatDateForFr(contract.dateCreated)
          : "",
      (contract) =>
        !!contract.dateValidFrom
          ? formatDateForFr(contract.dateValidFrom)
          : "",
      (contract) =>
        !!contract.dateValidTo ? formatDateForFr(contract.dateValidTo) : "",
      (contract) => (!!contract.state ? t(getValueLabel((contract.state))) : ""),

    ];
    result.push((contract) => {
      if (!!contract.state) {
        const stateLabel = getValueLabel(contract.state);
        // Check if the state is Draft or Negotiable
        if (stateLabel === "Draft" || stateLabel === "Negotiable") {
          return (
            <div>
              <IconButton onClick={() => handleDeleteClick(contract)}>
                <DeleteForeverIcon />
              </IconButton>
            </div>
          );
        } else {
          return (
            <div>
              <Button onClick={() => handleInsureeDownload(contract)}>
                <SaveAltRoundedIcon />
              </Button>
            </div>
          );
        }
      }
      return null; // Return null if state is not provided
    });

    return result;
  };

  const handleRowsPerPageChange = (newPageSize) => {
    setPageSize(newPageSize);
    setPage(0); // Reset to the first page when changing page size
    setEndCursors(null);
    setStartCursors(null);
  };

  const handleRowDoubleClick = (rowData) => {
    navigate(`${PORTAL_CONTRACT}/:id=${decodeId(rowData.id)}`);
  };
  const handleNavigation = (direction) => {
    if (direction === "forward") {
      setEndCursors(null);
    } else if (direction === "backward") {
      setStartCursors(null);
    }
  };
  const buildQueryParams = (state) => {
    let params = Object.keys(state.filters)
      .filter((f) => !!state.filters[f]["filter"])
      .map((f) => state.filters[f]["filter"]);
    params.push(`isDeleted: false`);
    if (!state.beforeCursor && !state.afterCursor) {
      params.push(`first: ${state.pageSize}`);
    }
    if (!!state.afterCursor) {
      params.push(`after: "${state.afterCursor}"`);
      params.push(`first: ${state.pageSize}`);
    }
    if (!!state.beforeCursor) {
      params.push(`before: "${state.beforeCursor}"`);
      params.push(`last: ${state.pageSize}`);
    }
    if (!!state.orderBy) {
      params.push(`orderBy:["code"]`);
    }
    if (!!state.policyHolderId) {
      params.push(`policyHolder_Id: "${PolicyholderIdStore}"`);
    }
    return params;
  };
  return (
    <Grid container>
      <Grid item xs={12}>
        <StyledPaper>
          <StyledPaperHeader container alignItems="center" direction="row">
            <Grid item alignItems="center">
              <Typography variant="h6">{t("Declaration List")}</Typography>
            </Grid>
          </StyledPaperHeader>
          <TableN
            module="insuree"
            headers={headers()}
            // headerActions={headerActions}
            itemFormatters={itemFormatters()}
            items={policyHolderData ? policyHolderData : []}
            // error={!!errorFullfamilyPendingApproval ? errorFullfamilyPendingApproval : null}
            withSelection={"single"}
            withPagination={true}
            rowsPerPageOptions={[10, 50, 100]}
            defaultPageSize={5}
            page={page}
            pageSize={pageSize}
            count={pageInfo}
            // onChangePage={(event, newPage) => setPage(newPage)}
            onChangePage={(event, newPage) => {
              setPage(newPage);
              handleNavigation(newPage > page ? "forward" : "backward");
            }}
            onChangeRowsPerPage={handleRowsPerPageChange}
            onDoubleClick={handleRowDoubleClick}
          />
        </StyledPaper>
      </Grid>
      {deleteDialogOpen && <DialogBox
        open={deleteDialogOpen}
        onClose={() => setDeleteDialogOpen(false)}
        onAgree={handleDeleteAgree}
        title="Confirmation"
        content={t(`Are you sure you want to delete this Contract?`)}
        agreeLabel={t("delete")}
        disagreeLabel={t("cancel")}
      />}
    </Grid>
  );
}

export default ContractDeclarationTable;
